import type { GetStaticProps, NextPage } from 'next';
import { Trans, useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useState } from 'react';
import RegisterForm from '@components/forms/RegisterForm';
import CenteredLayout from '@components/layouts/CenteredLayout';
import Link from '@components/routing/Link';
import LandingFooter from '@components/ui/miscellaneous/LandingFooter/LandingFooter';

const RegisterPage: NextPage = () => {
  const { t } = useTranslation();
  const [registered, setRegistered] = useState(false);

  return (
    <CenteredLayout title={t('auth:register-title', { defaultValue: 'Register' })} className="md:w-[400px]" logo>
      {!registered ? (
        <>
          <RegisterForm onRegister={() => setRegistered(true)} />

          <LandingFooter>
            <p>
              <Trans i18nKey="already-have-an-account-q">
                Already have an account? <Link href="/auth/login">Sign in</Link>
              </Trans>
            </p>
          </LandingFooter>
        </>
      ) : (
        <div className="flex flex-col items-center space-y-4">
          <h1 className="text-2xl font-semibold">
            <Trans i18nKey="auth:welcome-to-deepsquare">Welcome to DeepSquare!</Trans>
          </h1>
          <div className="text-center space-y-4">
            <Trans i18nKey="auth:check-inbox">
              <p>Please check your inbox and click on the activation link.</p>
              <p>If you do not see the email in a few minutes, please check your "junk mail" or "spam" folder.</p>
            </Trans>
          </div>
        </div>
      )}
    </CenteredLayout>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: await serverSideTranslations(locale ?? 'en', ['common', 'auth']),
});

export default RegisterPage;
